import { I18N_NAMESPACES } from "@src/appV2/i18n/constants";
import { useTu } from "@src/appV2/i18n/useTu";
import { SettingRow } from "@src/appV2/redesign/components/SettingRow";

import { Button } from "../../components/Button";

interface SettingEditableContentProps {
  title: string;
  subtitle?: string;
  buttonLabel?: string;
  disabled?: boolean;
  onEdit: () => void;
}

export function SettingEditableContent({
  title,
  subtitle,
  buttonLabel,
  disabled = false,
  onEdit,
}: SettingEditableContentProps) {
  const { tu } = useTu(I18N_NAMESPACES.settings);

  return (
    <SettingRow
      title={title}
      subtitle={subtitle}
      disabled={disabled}
      action={
        <Button variant="outlined" size="small" disabled={disabled} onClick={onEdit}>
          {buttonLabel ?? tu("Edit")}
        </Button>
      }
    />
  );
}
